import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "C:\\Users\\hp\\Documents\\GitHub\\MelcoWebsite\\src\\components\\common\\Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Documents\\GitHub\\MelcoWebsite\\src\\components\\home\\AboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Documents\\GitHub\\MelcoWebsite\\src\\components\\home\\PartnerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Documents\\GitHub\\MelcoWebsite\\src\\components\\home\\ProductSec.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Documents\\GitHub\\MelcoWebsite\\src\\components\\home\\Systems.tsx");
